__turbopack_context__.v({
  "hero": "Hero-module__fxzPfG__hero",
  "heroContent": "Hero-module__fxzPfG__heroContent",
  "title": "Hero-module__fxzPfG__title",
});
